import { post ,getLonde } from "@/utils/http";
class prestore {
  // 基本情况
  getReceivableMonthAmount(parme){
      return post(
          '/ycMegController/getReceivableMonthAmount',parme
      )
  }
  // 未核销
  searchYCNoWriteTradeNoVerfiyMeg(parme){
    return post(
        '/ycMegController/searchYCNoWriteTradeNoVerfiyMeg',parme
    )   
  }
  // 消费记录
  searchYCWriteTradeMeg(parme){
    return post(
        '/ycMegController/searchYCWriteTradeMeg',parme
    )   
  }
  // 充值记录  
  searchYCPaymentMeg(parme){
    return post(
        '/ycMegController/searchYCPaymentMeg',parme
    )   
  }
  // /ycMegController/printYcTradeNoWrite

//   预存-消费记录
// 127.0.0.1:8082/cubc-msc-web/ycMegController/searchYCWriteTradeMeg
// {
//     "customerCode":"40000533",
//     "startDate":1638288000000,
//     "endDate":1640880000000,
//     "currentPage":1,
//     "pageSize":100
// }

// 预存-未核销记录
// 127.0.0.1:8082/cubc-msc-web/ycMegController/searchYCNoWriteTradeNoVerfiyMeg
// {
//     "customerCode":"40000533",
//     "startDate":1638288000000,
//     "endDate":1640880000000,
//     "currentPage":1,
//     "pageSize":10
// }

// 预存-充值明细
// 127.0.0.1:8082/cubc-msc-web/ycMegController/searchYCPaymentMeg
// {
//     "customerCode":"40000533",
//     "startDate":1638288000000,
//     "endDate":1640880000000,
//     "currentPage":1,
//     "pageSize":100
// }

// 预存--未核销总金额
// 127.0.0.1:8082/cubc-msc-web/ycMegController/getReceivableMonthAmount
// {
//     "customerCode":"40000533",
//     "startDate":1638288000000,
//     "endDate":1640880000000,
//     "currentPage":1,
//     "pageSize":100
// }

// 预存-充值明细-导出
// 127.0.0.1:8082/cubc-msc-web/ycMegController/printYCPayment
// {
//     "tableColumns":"充值时间,充值金额,付款方式",
//      "customerCode":"40000533",
//     "startDate":1638288000000,
//     "endDate":1640880000000
// }

// 预存-已核销明细-导出
// 127.0.0.1:8082/cubc-msc-web/ycMegController/printYcTradeWrite
// {
//     "tableColumns":"业务日期,运单号,目的地,付款方式,发货人名称,收货人名称,货物名称,计费重量,总金额,未核销金额,已核销金额,公布价运费,保价费,中转费,其他费用,对内备注",
//      "customerCode":"40000533",
//     "startDate":1638288000000,
//     "endDate":1640880000000
// }

// 预存-未核销米关系-导出
// 127.0.0.1:8082/cubc-msc-web/ycMegController/printYcTradeNoWrite
// {
//     "tableColumns":"业务日期,运单号,目的地,付款方式,发货人名称,收货人名称,货物名称,计费重量,总金额,未核销金额,已核销金额,公布价运费,保价费,中转费,其他费用,对内备注",
//      "customerCode":"40000533",
//     "startDate":1638288000000,
//     "endDate":1640880000000
// }
// 充值明细-导出
printYCPayment(parme){
  return getLonde(
      '/ycMegController/printYCPayment',parme
  )   
}
// 已核销页面导出
printYcTradeWrite(parme){
  return getLonde(
      '/ycMegController/printYcTradeWrite',parme
  )   
}
// 未核销页面导出
printYcTradeNoWrite(parme){
  return getLonde(
      '/ycMegController/printYcTradeNoWrite',parme
  )   
}
}
export default prestore